<template lang="">
	<div class="mt-8 push-web-responsive-note">
		<v-card class="filter--container d-flex">
			<span class="d-flex flex-row inputFilter">
        <input
          v-model="email"
          type="text"
          placeholder="Email"
        >
        <img class="imgResponsive" style="width:20px" src="../../../../static/images/email.svg">
      </span>
      <span class="d-flex flex-row inputFilter">
        <input
          v-model="message"
          type="text"
          placeholder="Mensagem"
        >
        <img class="imgResponsive" style="width:20px" src="../../../../static/images/message.svg">
      </span>
			<date-picker
				v-model="rangeDate"
				class="inputFilter d-flex align-center pl-1"
        format="DD/MM/YYYY HH:mm"
				placeholder="De"
        input-class="border"
        type="datetime"
        time-title-format="DD/MM/YYYY"
			>
			</date-picker>
      <date-picker
				v-model="rangeDateFinal"
				class="inputFilter d-flex align-center pl-1"
				format="DD/MM/YYYY HH:mm"
				placeholder="Até"
        input-class="border"
        type="datetime"
        time-title-format="DD/MM/YYYY"
			>
			</date-picker>

			<div class="button-wrapper d-flex justify-space-between">
				<button
          class="mr-5"
          :disabled="!disabled"
          @click="fetchLogs"
				>
					<clip-loader
						v-if="loading"
						:loading="loading"
						color="var(--white)"
						size="22px"
					/>
					<div
            v-if="!loading"
						class="button-wrapper--text"
						>
						<img src="../../../../static/images/search.svg">
						Buscar
					</div>
				</button>
				<button
					@click="clearForm"
          style="background: var(--white); border: 1px solid grey; color: var(--dark-grey)"
				>
					<clip-loader
						v-if="loadingClear"
						:loading="loadingClear"
						color="var(--black)"
						size="22px"
					/>
					<div
            v-if="!loadingClear"
						class="button-wrapper--text"
						>
						<img src="../../../../static/images/load.svg">
						Limpar
					</div>
				</button>
			</div>
		</v-card>

		<h4 style="fontSize: 20px" class="mt-12">Agendamentos e Logs</h4>
    <div v-if="!loading">
      <v-expansion-panels  class="mt-5">
				<v-expansion-panel @click="onExpansionPanelClick"
					v-for="(item, index) in itemsLogs" :key="index" class="mt-2 d-flex align-center flex-column rounded-lg" height="59" id="expansion-item">
					<v-expansion-panel-header hide-actions :disabled="!canOpen"  class="d-flex align-center" style="padding: 10px 2px; position: initial; cursor: auto">
						<span class="rounded borderL" style=""></span>
            <div class="d-flex align-center justify-space-between">
              <div class="responsiveItemName">
                <span class="mr-9 font-weight-black widthResponsive">{{item.email}}</span>
              </div>
              <div class="d-flex align-center justify-space-between">
                <span class="font-weight-black">Data do disparo:</span><span class="mr-9 ml-1">{{formatDate(item.date)}}</span>
                <span class="font-weight-black">Horário:</span><span class="mr-9 ml-1"> {{formatHour(item.date)}}</span>
                <div class="buttons_action">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <button
                        style="
                          border: 2px solid var(--grey-day-020);
                          height: 40px;
                          width: 40px;
                        "
                        class="b-4 mr-6 d-flex justify-center align-center"
                        @click="getLogsDetails(item.id)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <img src="../../../../static/images/warning.svg"/>
                      </button>
                    </template>
                    <span>Clique aqui para mais detalhes</span>
                  </v-tooltip>
                </div>
              </div>
            </div>
					</v-expansion-panel-header>
					<v-expansion-panel-content class="responsive-note">
						<div class="d-flex flex-column">
							<span class="font-weight-black mt-4">Conteúdo</span>
							<span>{{idUser.message}}</span>
						</div>
						<div>
							<div class="d-flex flex-column">
								<span class="font-weight-black mt-4">Canal</span>
								<span>{{idUser.channelType}}</span>
							</div>
							<div class="d-flex flex-column">
								<span class="font-weight-black mt-4">Lista</span>
								<span>{{idUser.list}}</span>
							</div>
						</div>
						<div>
							<div class="d-flex flex-row align-center mt-4">
								<span class="font-weight-black">Url do Redirect:</span>
								<span class="ml-2" style="width: 990px; word-break:break-word">{{item.urlRedirect}}</span>
							</div>
						</div>
					</v-expansion-panel-content>
				</v-expansion-panel>
		</v-expansion-panels>
  </div>
  
  <div v-if="loading" class="d-flex justify-center align-center rounded" style="background: var(--white); width: auto; height: 200px">
    <span>Dados não encontrados!</span>
  </div>

  <div v-if="itemsLogs.length === 0 && !loading" class="mt-5 d-flex justify-center align-center rounded" style="background: var(--white); width: auto; height: 200px">
    <span>Nenhum registro encontrado!</span>
  </div>
	
    <!-- Pagination -->
    <v-card class="mt-8 mb-1">
      <div v-if="!loading" class="list-footer">
        <span></span>
        <v-pagination
          v-model="page"
          :length="numberPages"
          color="#F0F1F3"
          :total-visible="7"
          @input="nextPage"
        ></v-pagination>
        <div class="goToPage">
          <span class="goToPage--text"> Ir para página </span>
          <label>
            <input v-model="goToPage" type="text" />
            <button
              @click="goToPageRequest"
              :disabled="disabledGoTo"
            >
              <div class="button-wrapper--text">
                <i
                  class="
                    iconStyle
                    icon-arrow-right
                    d-flex
                    justify-center
                    align-center
                  "
                ></i>
              </div>
            </button>
            <span
              :class="
                showGoToPageHelpText ? '--show-helptext' : '--hide-helptext'
              "
              class="goToPage--helptext"
            >
              A página deve estar entre 1 e {{ numberPages }}
            </span>
          </label>
        </div>
      </div>
    </v-card>

    <div style="height: 5px"></div>
	</div>
</template>
<script>
// Libs
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";
import { mapActions, mapMutations, mapState } from "vuex";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import moment from 'moment'

//
import VueCookies from 'vue-cookies'

//mixins
import date from '../../../mixins/date'
import toaster from '../../../mixins/toaster'

export default {
  mixins: [date, toaster],
  components: {
    DatePicker,
    ClipLoader,
  },
  data() {
    return {
      disabled: false,
      loading: false,
      page: 1,
      goToPage: 1,
      disabledGoTo: false,
      showGoToPageHelpText: false,
      email: "",
      message: "",
      search_message: "",
      drawer: false,
      service: "",
      date: "",
      hasBorder: false,
      loadingClear: false,
      editForm: false,
      rangeDate: null,
      dayinitial: null,
      rangeDateFinal: null,
			canOpen: false,
    };
  },
  async created() {
    await this.fetchLogs();
  },
  computed: {
    ...mapState("Logs", {
			itemsLogs: 'itemsLogs',
      totalElements: "totalElements",
      currentPage: "current_page",
      logsToEdit: "logsToEdit",
      totalPages: "totalPages",
			idUser: 'idUser'
    }),
    widthScreen() {
      return window.screen.width > 1377;
    },
    numberPages () {
      return this.totalPages
    },
  },
  methods: {
    ...mapActions("Logs", ["allPushApp", "getDetails", "filterPushApp"]),
    ...mapMutations("Logs", {
      setCurrentPage: "SET_CURRENT_PAGE",
    }),
    onExpansionPanelClick(event) {
      if(event.currentTarget.classList.contains('v-expansion-panel-header--active')) {
        this.canOpen = false
      }
    },
    async nextPage (e) {
      this.goToPage = this.page
      this.setCurrentPage(e - 1)
      this.loading = false
      await this.fetchLogs()
    },
    async fetchLogs() {
      const token = VueCookies.get('jwt-login')
      this.loading = true;
      const size = 15
      const filter = this.buildFilter()
      try {
        await this.filterPushApp({ size, filter, token })
        this.loading = false
        this.loading = false
        this.disabled = false
      } catch (error) {
        this.loading = true
        console.error(error)
        this.toaster(
          error.message,
          'var(--red)',
          true
        )
      }
    },
    buildFilter () {
      let filter = ''
      if (this.email) filter += `&emailFilter=${this.email}`
      if (this.message) filter += `&messageFilter=${this.message}`
      if (this.rangeDate) filter += `&firstDate=${moment(this.rangeDate).format('YYYY-MM-DD HH:mm')}` 
      if (this.rangeDateFinal) filter += `&lastDate=${moment(this.rangeDateFinal).format('YYYY-MM-DD HH:mm')}`
      return filter
    },
		async getLogsDetails (id) {
      this.canOpen = true
      const token = VueCookies.get('jwt-login')
			try {
        await this.getDetails([id, token])
        this.canOpen = false
			}
			catch (error) {
        this.toaster(
          error.message,
          'var(--red)',
          true
        )
			}
		},
    async goToPageRequest() {
      this.loadingData = true;
      this.setCurrentPage(this.goToPage - 1);
      this.page = Number(this.goToPage)
      await this.filter();
      this.loadingData = false;
    },
    async clearForm () {
      this.loadingClear = true
      const token = VueCookies.get('jwt-login')
      const size = 15
      const filter = ''
      this.email = ''
      this.message = ''
      this.rangeDate = ''
      this.rangeDateFinal = ''
      this.setCurrentPage(0)
      this.goToPage = 1
      this.page = 1
      await this.filterPushApp({ size, filter, token })
      this.loadingClear = false
    },
  },
  watch: {
    'goToPage' () {
      if (this.goToPage < 1 || this.goToPage > this.totalPages) {
        this.showGoToPageHelpText = true;
        this.disabledGoTo = true;
      } else {
        this.showGoToPageHelpText = false;
        this.disabledGoTo = false;
      }
    },
    "email"() {
      this.email !== null
        ? (this.disabled = true)
        : (this.disabled = false);
    },
    "message"() {
      this.message !== null
        ? (this.disabled = true)
        : (this.disabled = false);
    },
    rangeDate() {
      this.rangeDate !== null
        ? (this.disabled = true)
        : (this.disabled = false);
    },
    rangeDateFinal() {
      this.rangeDateFinal !== null
        ? (this.disabled = true)
        : (this.disabled = false);
    },
  },
};
</script>
<style lang="scss" scoped>
.vs__clear {
  display: none;
}

.push-app__select {
  width: 190px;
}

.push-web-responsive-note {
  width: 1224px;

  .buttons_action {
    display: flex;
    justify-content: flex-end;
  }

  .vs__selected-options {
    width: 180px;
    padding-right: 3px;
  }

  .v-expansion-panel-header {
    padding: 7px 10px 7px 3px;
  }
  .mx-input {
    display: flex;
    height: 44px;
    border: none;
    outline: none;
  }

  .mx-input-wrapper {
    margin-top: -8px;
  }

  .filter--container {
    background: var(--white);
    border-radius: 4px;
    margin-bottom: 3.125rem;
    padding: 1.375rem;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    height: 88px;

    .inputFilter {
      border: 2px solid var(--grey-day-030);
      justify-content: space-between;
      height: 48px;
      padding: 7px;
      margin-right: 20px;
      border-radius: 4px;
      padding-left: 0;
      border-radius: 4px !important;
      font-family: "DM Sans Regular", sans-serif;

      .mx-input-wrapper {
        justify-content: center;
        padding-left: 0;
        font-family: "DM Sans Regular", sans-serif;
      }

      input {
        width: 100% !important;
        padding-left: 10px;
        font-family: "DM Sans Regular", sans-serif;
      }

      img {
        opacity: 0.5;
      }
    }

    label:focus-within {
      border: 2px solid var(--grey);
    }
    .button-wrapper {
      display: flex;
      justify-content: flex-end;

      &--text {
        display: flex;
        align-items: center;
      }

      button {
        background: var(--dark-red);
        border: none;
        border-radius: 4px;
        color: var(--white);
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: var(--dm-sans-medium);
        font-size: 1rem;
        padding: 0.875rem;
        min-height: 48px;
        width: 130px;

        img {
          margin-right: 0.875rem;
        }
      }

      button:disabled {
        background: #dddddd;
        cursor: not-allowed;
      }
    }
  }

  .b-4 {
    border: 2px solid var(--grey-day-030);
    border-radius: 4px;
  }

  .h-48 {
    height: 48px;
  }

  .vs__dropdown-toggle {
    border: none !important;
  }

  .vs__search {
    display: flex;
    align-items: center;
    padding: 7px;
    color: var(--dark-grey)
  }

  .list-footer {
    background: var(--white);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.75rem 2.625rem;
    margin: 80px 0 10px 0;
    height: 64px;
  }

  .v-pagination__navigation,
  .v-pagination__item {
    border: none;
    box-shadow: none;
  }

  .goToPage {
    &--text {
      font-size: 14px;
      font-family: var(--dm-sans-regular);
      color: var(--dark-grey);
      margin-right: 20px;
    }

    label {
      border: 2px solid var(--grey-day-030);
      background: var(--white);
      border-radius: 4px;
      box-sizing: border-box;
      max-width: 84px;
      width: 80px;
      padding: 10px;
      position: relative;

      input {
        width: 54px;
        font-size: 1rem;
        color: var(--grey);
        font-family: var(--dm-sans-regular);
      }

      button {
        position: absolute;
        border-radius: 50%;
        border: none;
        padding: 0;
        top: 11px;
        right: 8px;
        background: var(--grey);
        cursor: pointer;

        i {
          color: var(--white);
          font-size: 1.25rem;
        }
      }

      button:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }

    &--helptext {
      font-family: var(--dm-sans-regular);
      position: absolute;
      font-size: 12px;
      width: 120px;
      text-align: center;
      top: -55px;
      left: -24px;
      background: var(--dark-red);
      padding: 8px;
      color: var(--light-grey);
      border-radius: 4px;
    }

    .--hide-helptext {
      display: none;
    }

    .--show-helptext {
      display: block;
    }
  }

  .iconStyle {
    width: 20px;
    height: 20px;
    background: transparent;
  }

  .borderL {
    height: 49px;
    max-width: 3px !important;
    width: 13px;
    background-color: var(--blue);
    margin: 0 3px;
    position: absolute;
  }

  .v-expansion-panel--active .borderL {
    height: initial;
    // max-width: 3px !important;
    transition: 0.3s;
    width: 4px;
    background-color: var(--blue);
    margin: 0px 3px;
    position: absolute;
    top: 9px;
    bottom: 9px;
  }
}

.v-application .widthResponsive {
  width: 10%;
  margin-left: 50px;
}

@media screen and (max-width: 1377px) {
  .responsiveItemName {
    display: flex;
    align-items: flex-start;
  }

  .v-application {
    .widthResponsive {
      margin-top: 0;
    }
    
    .push-web-responsive-note {
      width: 830px;

      .filter--container {
        height: initial;

        &.d-flex {
          display: grid !important;
          grid-template-columns: 1fr 1fr;
          gap: 8px;
        }

        .button-wrapper {
          grid-row: 4;
          grid-column: 1 / -1;
          justify-self: flex-start;
        }
        .inputFilter {
          width: 100%;

          &:nth-child(1) {
            grid-row: 1;
            grid-column: 1 / -1;
          }

          &:nth-child(2) {
            grid-row: 2;
            grid-column: 1 / -1;
          }

          &:nth-child(3) {
            grid-row: 3;
          }

          &:nth-child(4) {
            grid-row: 3;
          }

          &.mx-datepicker:nth-child(3) {
            // margin-bottom: -48px;
            // width: 48%;
          }
        }
      }

      .v-expansion-panel--active {
          .borderL {
            height: 320px;
          }
      }
    }
  }

  .push-web-responsive-note {
    .filter--container {
      .mx-datepicker:nth-child(4) {
        grid-column: 2;
        grid-row: 3;
      }
    }

    .responsive-note {
      max-width: 55%;
      align-self: self-start;
      margin-left: 27px !important;
    }

    .widthResponsive {
      width: 200px;
    }
    .inputFilter {
      width: 114px;
    }
    .imgResponsive {
      display: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Contents/ScheduleWeb/Logs.vue